import Cookies from "js-cookie";
import CryptoJS from 'crypto-js';

export function setCookie(name, value, days = 0) {
    const encryptedData = CryptoJS.AES.encrypt(value, process.env.REACT_APP_TOKEN_CRYPTO_JS).toString();

    Cookies.set(name, encryptedData, { expires: days });
}

export function getCookie(name) {
    try {
        const encryptedData = Cookies.get(name);

        if (encryptedData) {
            const bytes = CryptoJS.AES.decrypt(encryptedData, process.env.REACT_APP_TOKEN_CRYPTO_JS);
            return bytes.toString(CryptoJS.enc.Utf8);
        }
        return null;
    }
    catch {
        return null;
    }
}

export function removeCookie(name) {
    return Cookies.remove(name);
}

export const logout = () => {
    removeCookie("authToken");

    window.location.href = "/login";
}


export function parseLocalDate(dateStr) {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day); // mês começa em 0
}

export const transformDatePtBR = (date) => {
    return date?.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    })
}

export function formatDateToPtBr(dateStr) {
    if (!dateStr) return '';

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';

    return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}

export function formatDateToPtBrDateTime(dateStr) {
    if (!dateStr) return '';

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';

    return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
}

export const convertUrlToImage = async (fileName, url) => {
    return await fetch(url)
        .then(async response => {
            const arr = url.split('.');
            const type = arr[arr.length - 1];
            const blob = await response.blob()
            const file = new File([blob], `${fileName}.${type}`, { type: `image/${type}` });
            return file;
        })
}

export const base64ToBlob = (base64, mimeType = 'image/jpeg') => {
    const byteString = atob(base64.split(',')[1]); // Decodifica a base64
    const arrayBuffer = new Uint8Array(byteString.length);

    for (let i = 0; i < byteString.length; i++) {
        arrayBuffer[i] = byteString.charCodeAt(i);
    }

    return new Blob([arrayBuffer], { type: mimeType });
};

export const base64ToFile = (base64, fileName, mimeType = 'image/jpeg') => {
    const byteString = atob(base64.split(',')[1]);
    const arrayBuffer = new Uint8Array(byteString.length);

    for (let i = 0; i < byteString.length; i++) {
        arrayBuffer[i] = byteString.charCodeAt(i);
    }

    return new File([arrayBuffer], `${fileName}.${mimeType.split('/')[1]}`, {
        type: mimeType,
    });
};

export function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(Number(n));
}

export function isEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
}

export function validarDominio(dominio) {
    // Expressão regular para validar domínios
    const regex = /^(?!-)(?!.*--)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    return regex.test(dominio);
}
